import cartConfigLogo from "../../assets/image/svg/cartConfig.svg";
import loginConfigLogo from "../../assets/image/svg/loginConfigLogo.svg";
import skuTileConfigLogo from "../../assets/image/svg/skuTileConfig.svg";
import checkoutConfigLogo from "../../assets/image/svg/checkoutConfig.svg";
import orderConfirmaionConfigLogo from "../../assets/image/svg/orderConfirmation.svg";
import orderTrackingConfigLogo from "../../assets/image/svg/orderTrackingConfig.svg";
import aiTaskConfigLogo from "../../assets/image/svg/aiTaskConfigLogo.svg";
import kpiConfigLogo from "../../assets/image/svg/kpiConfigLogo.svg";
import bannerConfigLogo from "../../assets/image/svg/bannerConfigLogo.svg";
import taskFilterConfigLogo from "../../assets/image/svg/taskFilterConfigLogo.svg";
import taskProgressDashboardConfigLogo from "../../assets/image/svg/taskProgressDashboardConfigLogo.svg";
import pjpConfigLogo from "../../assets/image/svg/pjpConfigLogo.svg";
import outletListConfigLogo from "../../assets/image/svg/outletListConfigLogo.svg";
import remoteOrderConfigLogo from "../../assets/image/svg/remoteOrderConfigLogo.svg";
import visitOrderConfigLogo from "../../assets/image/svg/visitOrderConfigLogo.svg";
import storeInOutConfigLogo from "../../assets/image/svg/uiThemeConfig.svg";
import recommendationConfigLogo from "../../assets/image/svg/uiThemeConfig.svg";
import outletTaskTileConfigLogo from "../../assets/image/svg/uiThemeConfig.svg";
import outletProfileConfigLogo from "../../assets/image/svg/outletProfileConfigLogo.svg";
import catalogFilterConfigLogo from "../../assets/image/svg/uiThemeConfig.svg";
import catalogueConfigLogo from "../../assets/image/svg/catalogueConfig.svg";
import oneClickOrderConfigLogo from "../../assets/image/svg/oneClickOrderConfigLogo.svg";
import attendanceConfigLogo from "../../assets/image/svg/uiThemeConfig.svg";
import orderFeedbackConfigLogo from "../../assets/image/svg/orderFeedbackConfigLogo.svg";
import supportConfigLogo from "../../assets/image/svg/uiThemeConfig.svg";
import incentiveConfigLogo from "../../assets/image/svg/incentiveConfigLogo.svg";
import teleOrderConfigLogo from "../../assets/image/svg/teleOrderConfigLogo.svg";
import competitionTrackingConfigLogo from "../../assets/image/svg/competitionTrackingConfigLogo.svg";
import merchandisingConfigLogo from "../../assets/image/svg/uiThemeConfig.svg";
import stockInventoryConfigLogo from "../../assets/image/svg/stockInventoryConfigLogo.svg";
import kpiHintImage from "../../assets/image/png/feautre-selection-bg.png";
import competetionTrackingImage from "../../assets/image/png/competetionTrackingLogo.png";
import incentiveImage from "../../assets/image/png/incentiveLogo.png";
import merchandisingImage from "../../assets/image/png/merchandisingLogo.png";
import recomendationImage from "../../assets/image/png/recomendationTaskLogo.png";
import stockInventoryImage from "../../assets/image/png/stockInventory.png";
import teleOrderImage from "../../assets/image/png/teleOrderLogo.png";
import uiThemeConfigLogo from "../../assets/image/svg/uiThemeConfig.svg";
import projectConfigLogo from "../../assets/image/svg/projectConfig.svg";

export const ImageIdToSVGMap: Record<string, string> = {
  uiThemeConfigLogo: uiThemeConfigLogo,
  projectConfigLogo: projectConfigLogo,
  incentiveConfigLogo: incentiveConfigLogo,
  teleOrderConfigLogo: teleOrderConfigLogo,
  competitionTrackingConfigLogo: competitionTrackingConfigLogo,
  merchandisingConfigLogo: merchandisingConfigLogo,
  stockInventoryConfigLogo: stockInventoryConfigLogo,
  kpiHintImage: kpiHintImage,
  cartConfigLogo: cartConfigLogo,
  loginConfigLogo: loginConfigLogo,
  skuTileConfigLogo: skuTileConfigLogo,
  checkoutConfigLogo: checkoutConfigLogo,
  orderConfirmaionConfigLogo: orderConfirmaionConfigLogo,
  orderTrackingConfigLogo: orderTrackingConfigLogo,
  aiTaskConfigLogo: aiTaskConfigLogo,
  kpiConfigLogo: kpiConfigLogo,
  bannerConfigLogo: bannerConfigLogo,
  taskFilterConfigLogo: taskFilterConfigLogo,
  taskProgressDashboardConfigLogo: taskProgressDashboardConfigLogo,
  pjpConfigLogo: pjpConfigLogo,
  outletListConfigLogo: outletListConfigLogo,
  remoteOrderConfigLogo: remoteOrderConfigLogo,
  visitOrderConfigLogo: visitOrderConfigLogo,
  storeInOutConfigLogo: storeInOutConfigLogo,
  recommendationConfigLogo: recommendationConfigLogo,
  outletTaskTileConfigLogo: outletTaskTileConfigLogo,
  outletProfileConfigLogo: outletProfileConfigLogo,
  catalogFilterConfigLogo: catalogFilterConfigLogo,
  catalogueConfigLogo: catalogueConfigLogo,
  oneClickOrderConfigLogo: oneClickOrderConfigLogo,
  attendanceConfigLogo: attendanceConfigLogo,
  orderFeedbackConfigLogo: orderFeedbackConfigLogo,
  supportConfigLogo: supportConfigLogo,
  incentiveImage: incentiveImage,
  teleOrderImage: teleOrderImage,
  competetionTrackingImage: competetionTrackingImage,
  merchandisingImage: merchandisingImage,
  recomendationImage: recomendationImage,
  stockInventoryImage: stockInventoryImage,
  default: uiThemeConfigLogo, // Fallback image
};

export const featureConfiguration = [
  {
    "id": "App essentials",
    "icon": "projectConfigLogo",
    "subfeatures": [
      {
        "id": "Project",
        "featureConfigName": "project",
        "domainMapping": {
          "clientconfig": [
            "app_configuration",
            "customer_configuration",
            "auth_config",
            "project_configuration"
          ]
        },
        "appType": "standard",
        "supportedAppTypes": [
          "sfa",
          "eb2b"
        ],
        "route": "",
        "configuration": [
          {
            "name": "lob",
            "domainType": "",
            "loaders": [],
            "section": "Basic Configurations",
            "uiSchema": {
              "question": "LOB Name",
              "config": "custom",
              "displayType": "select",
              "description": {},
              "vailidations": [],
              "dependsOn": {}
            }
          },
          {
            "name": "appName",
            "loaders": [],
            "domainType": "app_configuration",
            "section": "Basic Configurations",
            "uiSchema": {
              "question": "App Name",
              "config": "json",
              "displayType": "textfield",
              "description": " Display name shown in the application name and system menus",
              "vailidations": [],
              "dependsOn": {}
            }
          },
          {
            "name": "countryCode",
            "loaders": [],
            "section": "Basic Configurations",
            "domainType": "customer_configuration",
            "uiSchema": {
              "question": "Enter country code",
              "config": "custom",
              "displayType": "select",
              "validations": [],
              "dependsOn": {},
              "affectedValues": [
                "countryCode",
                "dialCode",
                "clientTimeZone",
                "currencySymbol",
                "currency"
              ],
              "description": {
                "countryCode": "Country ISO code (e.g., IN)",
                "dialCode": "Country phone code (e.g., 91)",
                "clientTimeZone": "time zone (e.g., Asia/Kolkata)",
                "currencySymbol": "Currency Symbol shown near prices (e.g., ₹, $)",
                "currency": "Currency shown near prices (e.g.,INR,USD)"
              }
            }
          },
          {
            "name": "supportNumber",
            "loaders": [],
            "section": "Basic Configurations",
            "domainType": "customer_configuration",
            "uiSchema": {
              "question": "Enter support number",
              "config": "json",
              "displayType": "textfield",
              "validations": {
                "regex": "^.{10,15}$"
              },
              "description": "Tap-to-call support helpline",
              "dependsOn": {}
            }
          },
          {
            "name": "teesting123",
            "domainType": "project_configuration",
            "section": "testingt",
            "loaders": [
              "config"
            ],
            "uiSchema": {
              "question": "project_configuration question to setup something",
              "config": "json",
              "description": "project_configuration question to setup something vproject_configuration question to setup somethingproject_configuration question to setup something",
              "displayType": "textfield",
              "vailidations": {},
              "dependsOn": {}
            }
          }
        ]
      },
      {
        "id": "UI and Theme",
        "featureConfigName": "uiandtheme",
        "icon": "uiThemeConfigLogo",
        "domainMapping": {
          "clientconfig": [
            "app_configuration",
            "theme_configuration"
          ]
        },
        "appType": "standard",
        "supportedAppTypes": [
          "sfa",
          "eb2b",
          "dms"
        ],
        "route": "",
        "configuration": [
          {
            "name": "clientLogo",
            "section": "Branding & Identity",
            "domainType": "app_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Upload brand logo",
              "config": "json",
              "displayType": "image",
              "description": "Login/logo mark. Recommended: 512×512 (.png/.jpg). Pair with logo height",
              "validations": {
                "height": 512,
                "width": 512,
                "max": true
              }
            }
          },
          {
            "name": "clientLogoHeight",
            "section": "Branding & Identity",
            "domainType": "app_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Enter brand logo height (px)",
              "description": "Pixel height for the login/client logo",
              "config": "json",
              "displayType": "textfield",
              "validations": {
                "regex": "^[1-9]\\d*$"
              }
            }
          },
          {
            "name": "clientHeaderLogo",
            "section": "Branding & Identity",
            "domainType": "app_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Upload header logo",
              "config": "json",
              "description": "Logo in the app header (top bar)",
              "displayType": "image",
              "validations": {
                "height": 512,
                "width": 512,
                "max": true
              }
            }
          },
          {
            "name": "clientHeaderLogoHeight",
            "section": "Branding & Identity",
            "domainType": "app_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Enter header logo height (px)",
              "description": "Pixel height for the header logo",
              "config": "json",
              "displayType": "textfield",
              "validations": {
                "textType": "number"
              }
            }
          },
          {
            "name": "appIcon",
            "section": "Branding & Identity",
            "domainType": "app_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Upload app icon",
              "config": "json",
              "description": "Launcher icon shown on device/home screen",
              "displayType": "image",
              "validations": {
                "height": 512,
                "width": 512,
                "max": true
              }
            }
          },
          {
            "name": "loginBanner",
            "section": "Branding & Identity",
            "domainType": "app_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Upload login banners",
              "config": "json",
              "displayType": "image",
              "description": "Banner for the login screen (recommended 720×540)",
              "loaders": [],
              "validations": {
                "height": 540,
                "width": 720,
                "max": true
              }
            }
          },
          {
            "name": "moreScreenLogo",
            "section": "Branding & Identity",
            "domainType": "app_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Upload More/About screen logo",
              "config": "json",
              "description": "Logo shown on the About/More screens",
              "displayType": "image",
              "validations": {
                "height": 512,
                "width": 512,
                "max": true
              }
            }
          },
          {
            "name": "appBarBackgroundType",
            "section": "App Bar & Theme",
            "domainType": "app_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Select app bar background type",
              "config": "custom",
              "displayType": "select",
              "validations": {
                "options": [
                  "solid",
                  "gradient",
                  "image"
                ]
              },
              "affectedValues": [
                "appBarBackgroundType",
                "solidAppBarColor",
                "gradientAppBarColor",
                "appbarBackgroundImage"
              ],
              "description": {
                "appBarBackgroundType": "Determines top bar style",
                "solidAppBarColor": "Used when background type is solid",
                "gradientAppBarColor": " Primary color for gradient app bar",
                "appbarBackgroundImage": "Shown when background type is image"
              }
            }
          },
          {
            "name": "themeColor",
            "section": "App Bar & Theme",
            "domainType": "app_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Pick primary theme color",
              "config": "json",
              "description": "Primary brand color across the app",
              "displayType": "colorInput",
              "validations": {}
            }
          },
          {
            "name": "themeBackGroundColor",
            "section": "App Bar & Theme",
            "domainType": "theme_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Pick background color",
              "config": "json",
              "description": "App background surface color",
              "displayType": "colorInput",
              "validations": {}
            }
          },
          {
            "name": "themeDisabledButtonColor",
            "section": "App Bar & Theme",
            "domainType": "theme_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Pick disabled button color",
              "config": "json",
              "description": "Color for disabled actions",
              "displayType": "colorInput",
              "validations": {}
            }
          },
          {
            "name": "activeLanguageColor",
            "section": "App Bar & Theme",
            "domainType": "theme_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Pick active language color",
              "description": "Highlight color for the selected language chip",
              "config": "json",
              "displayType": "colorInput",
              "validations": {}
            }
          }
        ]
      },
      {
        "id": "Authentication",
        "icon": "loginConfigLogo",
        "domainMapping": {
          "clientconfig": [
            "authentication_configuration",
            "password_configuration"
          ]
        },
        "featureConfigName": "authentication",
        "supportedAppTypes": [
          "sfa",
          "eb2b",
          "dms"
        ],
        "route": "",
        "configuration": [
          {
            "name": "loginType",
            "section": "Login Configurations",
            "domainType": "authentication_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Choose the primary sign-in method",
              "config": "json",
              "displayType": "select",
              "validations": {
                "options": [
                  "password",
                  "otp",
                  "otpAndPassword"
                ]
              },
              "description": "Choose the primary sign-in method"
            }
          },
          {
            "name": "deviceUID",
            "section": "Login Configurations",
            "loaders": [],
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "Show device UID on login?",
              "config": "json",
              "description": "Display the device’s unique ID on the login screen (useful for support/mapping)",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "termsChecked",
            "section": "Login Configurations",
            "loaders": [],
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "Terms & Conditions required?",
              "description": "Force users to accept T&C before login",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "otpProvider",
            "section": "Login Configurations",
            "loaders": [],
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "OTP provider",
              "description": "Select provider responsible for OTP generation/validation",
              "config": "json",
              "displayType": "select",
              "dependsOn": {
                "loginType": "otp"
              },
              "validations": {
                "options": [
                  "vonage",
                  "other"
                ]
              }
            }
          },
          {
            "name": "otpType",
            "section": "Login Configurations",
            "loaders": [],
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "OTP Type",
              "description": "Choose where the user receives OTP",
              "config": "json",
              "displayType": "select",
              "dependsOn": {
                "loginType": "otp"
              },
              "validations": {
                "options": [
                  "sms",
                  "smsAndWhatsapp"
                ]
              }
            }
          },
          {
            "name": "otpLength",
            "section": "Login Configurations",
            "loaders": [],
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "OTP length (digits)",
              "description": "Set the number of digits for the OTP",
              "config": "json",
              "displayType": "textfield",
              "dependsOn": {
                "loginType": "otp"
              },
              "validations": {
                "min": 4,
                "max": 10
              }
            }
          },
          {
            "name": "otpDisclaimer",
            "section": "Login Configurations",
            "loaders": [],
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "OTP Disclaimer",
              "description": "Message shown on OTP page (max ~30 chars).",
              "config": "json",
              "displayType": "textfield",
              "dependsOn": {
                "loginType": "otp"
              },
              "validations": {
                "maxLength": 30
              }
            }
          },
          {
            "name": "phoneNumberMaximumLength",
            "section": "Login Configurations",
            "loaders": [],
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "Phone number — maximum length",
              "description": "Max digits allowed for phone input.",
              "config": "json",
              "displayType": "textfiled",
              "dependsOn": {
                "loginType": "otp"
              },
              "validations": {
                "min": 1,
                "max": 20
              }
            }
          },
          {
            "name": "phoneNumberMinimumLength",
            "section": "Login Configurations",
            "loaders": [],
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "Phone number — minimum length",
              "description": "Min digits required for phone input.",
              "config": "json",
              "dependsOn": {
                "loginType": "otp"
              },
              "displayType": "textfield",
              "validations": {
                "min": 1,
                "max": 20
              }
            }
          },
          {
            "name": "captureLocationAfterLogin",
            "section": "Login Configurations",
            "loaders": [],
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "Capture location after login?",
              "description": "Prompt for location permission immediately after login.",
              "config": "json",
              "dependsOn": {
                "loginType": "otp"
              },
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "userLoginBlock",
            "section": "Password Retry and Lockout",
            "loaders": [],
            "domainType": "password_configuration",
            "uiSchema": {
              "question": "Capture location after login?",
              "description": "Prompt for location permission immediately after login.",
              "config": "custom",
              "displayType": "custom",
              "validations": {},
              "affectedValues": [
                "userLoginBlock"
              ]
            }
          },
          {
            "name": "userInactivityBlock",
            "section": "Deactive Inactive Users",
            "loaders": [],
            "domainType": "password_configuration",
            "uiSchema": {
              "question": "Capture location after login?",
              "description": "Prompt for location permission immediately after login.",
              "config": "custom",
              "displayType": "custom",
              "validations": {},
              "affectedValues": [
                "userInactivityBlock"
              ]
            }
          }
        ]
      }
    ]
  },
  {
    "id": "Must Do Action",
    "icon": "teleOrderConfigLogo",
    "subfeatures": [
      {
        "id": "Must Do Action",
        "featureConfigName": "mustdoaction",
        "domainMapping": {
          "clientconfig": [
            "must_do_action_configuration",
            "customer_configuration"
          ]
        },
        "appType": "standard",
        "supportedAppTypes": [
          "sfa",
          "eb2b"
        ],
        "route": "",
        "configuration": [
          {
            "name": "mustDoActionCard",
            "domainType": "must_do_action_configuration",
            "section": "Manage Must Do Action",
            "loaders": [],
            "uiSchema": {
              "question": "list of must do actions",
              "config": "custom",
              "displayType": "multipleCheckbox",
              "validations": [],
              "affectedValues": [
                "mustDoActionCard",
                "outletTabFilters"
              ]
            }
          },
          {
            "name": "outletTabFilters",
            "domainType": "must_do_action_configuration",
            "section": "Manage Must Do Action",
            "loaders": [],
            "uiSchema": {
              "question": "list of outlet Tab Filters",
              "config": "custom",
              "displayType": "multipleCheckbox",
              "validations": []
            }
          },
          {
            "name": "focusProductsLabel",
            "domainType": "must_do_action_configuration",
            "section": "Manage Must Do Action",
            "loaders": [],
            "uiSchema": {
              "question": "focus products label",
              "config": "json",
              "displayType": "textfield",
              "validations": []
            }
          },
          {
            "name": "liveUpdateLabel",
            "domainType": "must_do_action_configuration",
            "section": "Manage Must Do Action",
            "loaders": [],
            "uiSchema": {
              "question": "live update label",
              "config": "json",
              "displayType": "textfield",
              "validations": []
            }
          },
          {
            "name": "premiumProductsLabel",
            "domainType": "must_do_action_configuration",
            "section": "Manage Must Do Action",
            "loaders": [],
            "uiSchema": {
              "question": "premium products label",
              "config": "json",
              "displayType": "textfield",
              "validations": []
            }
          }
        ]
      }
    ]
  },
  {
    "id": "KPI Review",
    "icon": "kpiConfigLogo",
    "subfeatures": [
      {
        "id": "KPI review",
        "appType": "standard",
        "supportedAppTypes": [
          "sfa",
          "eb2b"
        ],
        "route": "",
        "featureConfigName": "kpireview",
        "domainMapping": {
          "clientconfig": [
            "kpi_configuration"
          ]
        },
        "configuration": [
          {
            "name": "kpiConfigList",
            "section": "Manage KPI Configuration",
            "loaders": [],
            "domainType": "kpi_configuration",
            "uiSchema": {
              "question": "list of kpi configs",
              "config": "custom",
              "loaders": [],
              "displayType": "custom",
              "validations": [],
              "description": {
                "kpiConfigList": "list of KPIs to be displayed in the app"
              },
              "affectedValues": [
                "kpiConfigList"
              ]
            }
          }
        ]
      }
    ]
  },
  {
    "id": "Catalogue",
    "icon": "catalogueConfigLogo",
    "subfeatures": [
      {
        "id": "Catalogue",
        "appType": "standard",
        "domainMapping": {
          "clientconfig": [
            "catalogue_configuration",
            "tab_filters",
            "order_configuration"
          ]
        },
        "route": "",
        "supportedAppTypes": [
          "sfa",
          "eb2b"
        ],
        "featureConfigName": "catalogue",
        "configuration": [
          {
            "name": "catalogue",
            "section": "Catalogue Filter",
            "loaders": [],
            "domainType": "catalogue_configuration",
            "uiSchema": {
              "question": "Display Product Validation",
              "config": "custom",
              "loaders": [],
              "displayType": "custom",
              "validations": [],
              "affectedValues": [
                "tabFilterType"
              ]
            }
          },
          {
            "name": "tabFilters",
            "section": "Catalogue Filter",
            "loaders": [],
            "domainType": "tab_filters",
            "uiSchema": {
              "question": "Display Tab Filters",
              "config": "custom",
              "loaders": [],
              "displayType": "custom",
              "validations": [],
              "affectedValues": [
                "tabFilters"
              ]
            }
          },
          {
            "name": "Dummy Image Upload",
            "section": "Dummy Image Upload",
            "loaders": [],
            "domainType": "catalogue_configuration",
            "uiSchema": {
              "question": "Display Product Validation",
              "config": "custom",
              "displayType": "custom",
              "validations": [],
              "affectedValues": [
                "defaultCatalogueImage"
              ]
            }
          },
          {
            "name": "Labels",
            "section": "Labels",
            "loaders": [],
            "domainType": "catalogue_configuration",
            "uiSchema": {
              "question": "Display Product Validation",
              "config": "custom",
              "displayType": "custom",
              "validations": [],
              "affectedValues": [
                "focCaseUnitLabel",
                "casePtrLabel",
                "focPackUnitLabel",
                "packPtrLabel",
                "focOtherUnitLabel",
                "otherPtrLabel",
                "mrpLabel",
                "multiVariantHeader"
              ]
            }
          },
          {
            "name": "showSkuCode",
            "section": "SKU tile",
            "loaders": [],
            "domainType": "catalogue_configuration",
            "uiSchema": {
              "question": "Display Product Validation",
              "config": "custom",
              "displayType": "custom",
              "validations": [
                "skuCodeVisibility",
                "skuCodeCondition",
                "pieceSizeVisibility",
                "pieceSizeLabel",
                "caseUnitLabel",
                "packUnitLabel",
                "otherUnitLabel",
                "maxAllowedDigitForOrder"
              ]
            }
          },
          {
            "name": "Similar Product",
            "section": "Similar Product Grouping & price format",
            "loaders": [],
            "domainType": "catalogue_configuration",
            "uiSchema": {
              "question": "Display Product Validation",
              "config": "custom",
              "displayType": "custom",
              "validations": [],
              "affectedValues": [
                "multiVariantOrder",
                "multiVariantGroupingOption"
              ]
            }
          },
          {
            "name": "priceFormatter",
            "section": "Similar Product Grouping & price format",
            "domainType": "catalogue_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Price Formatter",
              "config": "custom",
              "displayType": "textfield",
              "validations": [
                {
                  "type": "string",
                  "minLength": 1,
                  "maxLength": 50
                }
              ],
              "affectedValues": [
                "priceFormatter"
              ]
            }
          },
          {
            "name": "displayProductValidation",
            "domainType": "catalogue_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Display Product Validation",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "productTypeFilter",
            "domainType": "catalogue_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Product Type Filter",
              "config": "json",
              "displayType": "textfield",
              "validations": []
            }
          },
          {
            "name": "displayProductValidationFilter",
            "domainType": "catalogue_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Display Product Validation Filter",
              "config": "json",
              "displayType": "textfield",
              "validations": []
            }
          },
          {
            "name": "sspLabel",
            "domainType": "catalogue_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "SSP Label",
              "config": "json",
              "displayType": "textfield",
              "validations": [
                {
                  "type": "string",
                  "minLength": 1,
                  "maxLength": 30
                }
              ]
            }
          },
          {
            "name": "defaultQtyForOrder",
            "domainType": "catalogue_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Default Quantity For Order",
              "config": "json",
              "displayType": "textfield",
              "validations": [
                {
                  "type": "number",
                  "min": 1
                }
              ]
            }
          },
          {
            "name": "editPricing",
            "domainType": "catalogue_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Edit Pricing",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "outletLevelPricing",
            "domainType": "catalogue_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Outlet Level Pricing",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "enableEditPrice",
            "domainType": "catalogue_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Enable Edit Price",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "pricingMap",
            "domainType": "order_configuration",
            "section": "",
            "loaders": [],
            "uiSchema": {
              "question": "pricing map logic",
              "config": "json",
              "description": "pricing map logicpricing map logicpricing map logicpricing map logicpricing map logicpricing map logicpricing map logicpricing map logicpricing map logicpricing map logicpricing map logicpricing map logicpricing map logicpricing map logic",
              "displayType": "textfield",
              "vailidations": {},
              "dependsOn": {}
            }
          }
        ]
      }
    ]
  },
  {
    "id": "Order",
    "icon": "checkoutConfigLogo",
    "subfeatures": [
      {
        "id": "Order Summary",
        "domainMapping": {
          "clientconfig": [
            "order_configuration"
          ]
        },
        "appType": "standard",
        "featureConfigName": "ordersummary",
        "supportedAppTypes": [
          "sfa",
          "eb2b"
        ],
        "route": "",
        "configuration": [
          {
            "name": "distributorVisibility",
            "domainType": "order_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Visibility of Distributor/Supplier details in order checkout details",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "orderDSIdVisibility",
            "domainType": "order_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "to show distributor id",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "orderTncLink",
            "domainType": "order_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Upload orderTncLink",
              "config": "custom",
              "displayType": "file",
              "validations": [],
              "affectedValues": [
                "orderTncLink"
              ]
            }
          },
          {
            "name": "orderRemarksVisibility",
            "loaders": [],
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "To show order remarks input in order summary.",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "wholeSalerMarginVisibility",
            "loaders": [],
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "to show wholesaler margin",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "retailerMarginVisibility",
            "domainType": "order_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Visibility of Distributor/Supplier details in order checkout details",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "locationPopupOnOrder",
            "domainType": "order_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Location Capture while order placement",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "orderTncVisibility",
            "domainType": "order_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Term & Condition",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "orderConfirmationPopup",
            "domainType": "order_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "order confirmation popup",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "orderSummaryDisclaimer",
            "domainType": "order_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "order summary disclaimer",
              "config": "json",
              "displayType": "textfieldList",
              "validations": []
            }
          },
          {
            "name": "orderInvoiceDisclaimer",
            "domainType": "order_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "order invoice disclaimer",
              "config": "json",
              "displayType": "textfieldList",
              "validations": []
            }
          },
          {
            "name": "orderCheckoutTotalAmountLabel",
            "domainType": "order_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Label for Total Amount in order summary page.",
              "config": "json",
              "displayType": "textfield",
              "validations": []
            }
          },
          {
            "name": "orderCheckoutDiscountLabel",
            "domainType": "order_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Label for discount in order summary page.",
              "config": "json",
              "displayType": "textfield",
              "validations": []
            }
          },
          {
            "name": "orderSubmitButtonLabel",
            "domainType": "order_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Label for submit button in order summary page.",
              "config": "json",
              "displayType": "textfield",
              "validations": []
            }
          },
          {
            "name": "orderCheckoutFinalAmountLabel",
            "domainType": "order_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Label for checkoutTotal in order summary page.",
              "config": "json",
              "displayType": "textfield",
              "validations": []
            }
          }
        ]
      },
      {
        "id": "Order Tracking",
        "domainMapping": {
          "clientconfig": [
            "order_configuration"
          ]
        },
        "supportedAppTypes": [
          "sfa",
          "eb2b"
        ],
        "route": "",
        "appType": "standard",
        "featureConfigName": "ordertracking",
        "configuration": [
          {
            "name": "orderTrackingStages",
            "domainType": "order_configuration",
            "section": "Manage Order Tracking",
            "loaders": [],
            "uiSchema": {
              "question": "Order tracking stages",
              "config": "custom",
              "displayType": "multipleCheckbox",
              "validations": [],
              "affectedValues": [
                "orderTrackingStages",
                "orderTrackingDefaultRange"
              ]
            }
          },
          {
            "name": "reOrder",
            "domainType": "order_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Enable Re-order option for past orders",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "orderTrackingInvoiceTabVisibility",
            "domainType": "order_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Show Invoice Tab in Order Tracking",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "dmsSpecificOrderTrackingSummary",
            "domainType": "order_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Enable DMS-specific Order Tracking Summary",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "editOrder",
            "domainType": "order_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Allow editing orders after submission",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "rejectOrder",
            "domainType": "order_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Allow rejecting orders",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "deleteOrder",
            "domainType": "order_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Allow deleting orders",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          }
        ]
      },
      {
        "id": "Cart",
        "domainMapping": {
          "clientconfig": [
            "order_configuration"
          ]
        },
        "appType": "standard",
        "featureConfigName": "cart",
        "supportedAppTypes": [
          "sfa",
          "eb2b"
        ],
        "route": "",
        "configuration": [
          {
            "name": "orderFulfillmentType",
            "domainType": "order_configuration",
            "section": "Delivery Date",
            "loaders": [],
            "uiSchema": {
              "question": "Enable Persistent Cart Navigation Bar",
              "config": "custom",
              "displayType": "radio",
              "validations": []
            }
          },
          {
            "name": "orderFulfillmentTime",
            "domainType": "order_configuration",
            "section": "Delivery Date",
            "loaders": [],
            "uiSchema": {
              "question": "Enable Persistent Cart Navigation Bar",
              "config": "custom",
              "displayType": "radio",
              "validations": [],
              "affectedValues": [
                "orderFulfillmentTimeMessage",
                "orderFulfillmentTime"
              ]
            }
          },
          {
            "name": "missedItemBasket",
            "domainType": "order_configuration",
            "section": "Missed Product Carousel",
            "loaders": [],
            "uiSchema": {
              "question": "Enable Persistent Cart Navigation Bar",
              "config": "custom",
              "displayType": "custom",
              "validations": [],
              "affectedValues": [
                "missedItemBasket"
              ]
            }
          },
          {
            "name": "orderingCriteriaType",
            "domainType": "order_configuration",
            "section": "Ordering Validation",
            "loaders": [],
            "uiSchema": {
              "question": "Enable Persistent Cart Navigation Bar",
              "config": "custom",
              "displayType": "radio",
              "validations": [],
              "affectedValues": [
                "orderingConditions"
              ]
            }
          },
          {
            "name": "fullFilledByLabel",
            "domainType": "order_configuration",
            "section": "Labels",
            "loaders": [],
            "uiSchema": {
              "question": "Fulfilled By Label",
              "config": "json",
              "displayType": "textfield",
              "editable": true,
              "validations": [
                {
                  "type": "string",
                  "minLength": 3,
                  "maxLength": 50
                }
              ]
            }
          },
          {
            "name": "persistentCartNavigationBar",
            "domainType": "order_configuration",
            "section": "Cart Footer Bar",
            "loaders": [],
            "uiSchema": {
              "question": "Enable Persistent Cart Navigation Bar",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          }
        ]
      }
    ]
  },
  {
    "id": "PJP",
    "icon": "pjpConfigLogo",
    "subfeatures": [
      {
        "id": "Outlet List",
        "domainMapping": {
          "clientconfig": [
            "outlet_activity_configuration",
            "target_configuration"
          ]
        },
        "appType": "standard",
        "featureConfigName": "outletlist",
        "supportedAppTypes": [
          "sfa",
          "eb2b"
        ],
        "route": "",
        "configuration": [
          {
            "name": "outletScreenWidget",
            "domainType": "outlet_activity_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Add Outlet screen widgets to outlet screen",
              "config": "custom",
              "displayType": "checkbox",
              "affectedValues": [
                "outletScreenWidget"
              ],
              "description": {
                "outletScreenWidget": "Add Outlet screen widgets to outlet screen"
              }
            }
          },
          {
            "name": "outletTileOptions",
            "domainType": "outlet_activity_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Controls quick actions on the tile (Remote/Tele/Visit Order)",
              "config": "custom",
              "displayType": "table",
              "affectedValues": [
                "outletTileOptions"
              ],
              "description": {
                "outletTileOptions": "Controls quick actions on the tile (e.g., Remote Order, Tele Order, Visit Order)"
              }
            }
          },
          {
            "name": "outletTabFilters",
            "domainType": "must_do_action_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Control visibility of tabs (Sales Target, Must Order, Focus) on the Outlet screen",
              "config": "custom",
              "displayType": "table",
              "affectedValues": [
                "outletTabFilters"
              ],
              "description": {
                "outletTabFilters": "Control visibility of tabs (e.g., Sales Target, Must Order, Focus) on the Outlet screen"
              }
            }
          },
          {
            "name": "outletCodeVisibility",
            "section": "Card Content & Badges",
            "loaders": [],
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show outlet code on card?",
              "config": "json",
              "displayType": "toggle",
              "validations": {},
              "description": "Display the outlet code on each outlet card"
            }
          },
          {
            "name": "billedTagVisibility",
            "section": "Card Content & Badges",
            "loaders": [],
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show billed tag (monthly)?",
              "config": "json",
              "displayType": "toggle",
              "validations": {},
              "description": "Show a tag indicating monthly billing status. (green = billed this month, red = otherwise)"
            }
          },
          {
            "name": "additionalOutletTagVisibility",
            "section": "Card Content & Badges",
            "loaders": [],
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show additional outlet tag?",
              "config": "json",
              "displayType": "toggle",
              "validations": {},
              "description": "Display the additional (plan) tag on the outlet card"
            }
          },
          {
            "name": "outletCategoryVisibility",
            "section": "Card Content & Badges",
            "loaders": [],
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show outlet category on card?",
              "config": "json",
              "displayType": "toggle",
              "validations": {},
              "description": "Display outlet category badge"
            }
          },
          {
            "name": "marketIdVisibility",
            "section": "Card Content & Badges",
            "loaders": [],
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show Market ID on card?",
              "config": "json",
              "description": "Display the Market ID on the outlet card",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "outletTypeVisibility",
            "section": "Card Content & Badges",
            "loaders": [],
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show outlet type on card?",
              "config": "json",
              "description": "Display the outlet type badge",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "lastVisitDateVisibility",
            "section": "Card Content & Badges",
            "loaders": [],
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show last visit date on card?",
              "config": "json",
              "description": "Display the last visit date on the outlet card",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "outletClassBadge",
            "section": "Card Content & Badges",
            "loaders": [],
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show outlet class badge?",
              "config": "json",
              "description": "Display the outlet class on the outlet card",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "outletSortingTemplate",
            "section": "Sorting & Sequence",
            "loaders": [],
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Outlet sorting template",
              "config": "json",
              "description": "Sorting method for outlet lists/cards",
              "displayType": "select",
              "validations": {
                "options": [
                  "location",
                  "outletSequence"
                ]
              }
            }
          },
          {
            "name": "sequencedOutletVisitFlag",
            "section": "Sorting & Sequence",
            "loaders": [],
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Sequenced outlet visit required?",
              "description": "Force visiting outlets in the master sequence",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "blockOutletActivityForOutOfRange",
            "section": "Visit Flow & Access Control",
            "loaders": [],
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Block outlet activity if out of range?",
              "description": "Prevent actions if the user is outside the allowed range",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "blockOutletActivityOnLeave",
            "section": "Visit Flow & Access Control",
            "loaders": [],
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Block outlet activity on leave?",
              "description": "Block visit if attendance status indicates leave/absent",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "blockVisitFlow",
            "section": "Visit Flow & Access Control",
            "loaders": [],
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Enable outlet visit flow?",
              "config": "json",
              "description": "Use the guided outlet visit flow",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "targetType",
            "section": "Targets & Metrics",
            "loaders": [],
            "domainType": "target_configuration",
            "uiSchema": {
              "question": "Sales Target - Value/Volume?",
              "config": "json",
              "description": "Select whether you want to show sales target in value or volume",
              "displayType": "select",
              "validations": {
                "options": [
                  "value",
                  "volume"
                ]
              }
            }
          }
        ]
      },
      {
        "id": "Map and Geo-Fencing",
        "domainMapping": {
          "clientconfig": [
            "outlet_activity_configuration"
          ]
        },
        "appType": "standard",
        "featureConfigName": "mapandgeofencing",
        "supportedAppTypes": [
          "sfa",
          "eb2b"
        ],
        "route": "",
        "configuration": [
          {
            "name": "zoomMapToCurrentOutlet",
            "domainType": "outlet_activity_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Zoom map to current outlet",
              "config": "json",
              "description": "Auto-zoom the map to the selected outlet",
              "displayType": "toggle"
            }
          },
          {
            "name": "outletDistanceVisibility",
            "domainType": "outlet_activity_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Show distance to outlet on card",
              "description": "Display the current distance from the outlet",
              "config": "json",
              "displayType": "toggle"
            }
          },
          {
            "name": "outletNavigation",
            "domainType": "outlet_activity_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Show outlet navigation on card",
              "description": "Show a ‘Get Directions’ action that opens the maps app",
              "config": "json",
              "displayType": "toggle"
            }
          },
          {
            "name": "geolocationPopupVisibility",
            "domainType": "outlet_activity_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Show geolocation popup",
              "config": "json",
              "description": "Show a popup to get/confirm location",
              "displayType": "toggle"
            }
          },
          {
            "name": "storeInRange",
            "domainType": "outlet_activity_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Allowed store-in range (meters)",
              "config": "json",
              "description": "Distance within which a user is considered in range of the outlet",
              "displayType": "textfield",
              "validations": {
                "textType": "number"
              }
            }
          },
          {
            "name": "distanceFilterForLocation",
            "domainType": "outlet_activity_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Re-fetch distance after (meters)",
              "config": "json",
              "description": "Re-fetch user location after this distance change for live proximity sorting",
              "displayType": "textfield",
              "validations": {}
            }
          }
        ]
      },
      {
        "id": "PJP and Beat",
        "isSelected": false,
        "domainMapping": {
          "clientconfig": [
            "outlet_activity_configuration"
          ]
        },
        "appType": "standard",
        "featureConfigName": "pjpandbeat",
        "supportedAppTypes": [
          "sfa",
          "eb2b"
        ],
        "route": "",
        "configuration": [
          {
            "name": "pjpLabel",
            "domainType": "outlet_activity_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Enable PJP Toggle",
              "config": "json",
              "description": "Determines whether to show pjp toggle and what should be the value to display on toggle",
              "displayType": "textfield"
            }
          },
          {
            "name": "pjpBeatVisibility",
            "domainType": "outlet_activity_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Show PJP/Beat info on card",
              "config": "json",
              "description": "Display PJP/Beat details on the outlet card",
              "displayType": "toggle"
            }
          },
          {
            "name": "pjpBannerVisibility",
            "domainType": "outlet_activity_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Show PJP banner",
              "config": "json",
              "description": "Display PJP banner validation on the card",
              "displayType": "toggle"
            }
          },
          {
            "name": "deviatePjp",
            "domainType": "outlet_activity_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Deviate PJP flag (app bar)",
              "config": "json",
              "description": "Controls showing the Deviate PJP option",
              "displayType": "toggle"
            }
          }
        ]
      },
      {
        "id": "OutletMapping",
        "domainMapping": {
          "clientconfig": [
            "outlet_mapping"
          ]
        },
        "supportedAppTypes": [
          "sfa",
          "eb2b"
        ],
        "route": "",
        "appType": "standard",
        "featureConfigName": "outletmapping",
        "configuration": [
          {
            "name": "outletMappingTabs",
            "domainType": "outlet_mapping",
            "loaders": [],
            "uiSchema": {
              "question": "Outlet Mapping Tabs",
              "config": "custom",
              "displayType": "checkbox",
              "description": {
                "outletMappingTabs": "Choose which tabs are visible to users"
              },
              "validations": {
                "options": [
                  "Existing",
                  "New"
                ]
              },
              "affectedValues": [
                "outletMappingTabs"
              ]
            }
          },
          {
            "name": "cleanOutletMappingData",
            "domainType": "outlet_mapping",
            "loaders": [],
            "uiSchema": {
              "question": "Clean Outlet Mapping Data",
              "config": "custom",
              "displayType": "list",
              "description": {
                "cleanOutletMappingData": "Keys to retain/clean in payload"
              },
              "affectedValues": [
                "cleanOutletMappingData"
              ]
            }
          },
          {
            "name": "immediateParentTemplate",
            "domainType": "outlet_mapping",
            "loaders": [],
            "uiSchema": {
              "question": "Immediate Parent Template",
              "config": "json",
              "displayType": "textfield",
              "description": "How parent mapping is resolved."
            }
          },
          {
            "name": "featureConnectionType",
            "domainType": "outlet_mapping",
            "loaders": [],
            "uiSchema": {
              "question": "Feature Connection Type",
              "config": "json",
              "displayType": "textfield",
              "description": "Connectivity mode for this feature."
            }
          },
          {
            "name": "outletMappingSyncInfo",
            "loaders": [],
            "domainType": "outlet_mapping",
            "uiSchema": {
              "question": "Outlet Mapping Sync",
              "config": "custom",
              "displayType": "table",
              "description": {
                "outletMappingSyncInfo": "Sync source per tab"
              },
              "affectedValues": [
                "outletMappingSyncInfo"
              ]
            }
          },
          {
            "name": "getSubChannelApi",
            "domainType": "outlet_mapping",
            "loaders": [],
            "uiSchema": {
              "question": "GET Sub Channel API",
              "config": "json",
              "displayType": "select",
              "description": "API param to fetch sub-channel or channel from outletCategory.",
              "validations": {
                "options": [
                  "subChannel",
                  "channel"
                ]
              }
            }
          },
          {
            "name": "showActivityStatusTags",
            "domainType": "outlet_mapping",
            "loaders": [],
            "uiSchema": {
              "question": "Show Activity Status Tags",
              "config": "json",
              "displayType": "toggle",
              "description": "Show activity status tags on outlet cards."
            }
          },
          {
            "name": "outletCodeTemplate",
            "domainType": "outlet_mapping",
            "loaders": [],
            "uiSchema": {
              "question": "Outlet Code Template",
              "config": "json",
              "displayType": "textfield",
              "description": "Pattern used to generate outlet codes."
            }
          },
          {
            "name": "customerChannelDistributorMapping",
            "domainType": "outlet_mapping",
            "loaders": [],
            "uiSchema": {
              "question": "Customer Channel Distributor Mapping",
              "config": "custom",
              "displayType": "map",
              "description": {
                "customerChannelDistributorMapping": "Auto-map customer sub-category to distributor type."
              },
              "affectedValues": [
                "customerChannelDistributorMapping"
              ]
            }
          },
          {
            "name": "locationKeyMap",
            "domainType": "outlet_mapping",
            "loaders": [],
            "uiSchema": {
              "question": "Location Key Map",
              "config": "custom",
              "displayType": "jsonviewer",
              "description": {
                "locationKeyMap": "Form field → location key mapping"
              },
              "affectedValues": [
                "locationKeyMap"
              ]
            }
          },
          {
            "name": "updateOutletDetailsFromRequestBody",
            "domainType": "outlet_mapping",
            "loaders": [],
            "uiSchema": {
              "question": "Update Outlet Details from Request Body",
              "config": "json",
              "displayType": "toggle",
              "description": "Update outlet from request body (vs response)."
            }
          },
          {
            "name": "updateLocationOnImageCapture",
            "domainType": "outlet_mapping",
            "loaders": [],
            "uiSchema": {
              "question": "Update Location on Image Capture",
              "config": "json",
              "displayType": "toggle",
              "description": "Refresh lat/long when a photo is captured."
            }
          }
        ]
      }
    ]
  },
  {
    "id": "Attendance",
    "icon": "attendanceConfigLogo",
    "subfeatures": [
      {
        "id": "Attendance",
        "domainMapping": {
          "clientconfig": [
            "attendance_configuration"
          ]
        },
        "appType": "standard",
        "featureConfigName": "attendance",
        "supportedAppTypes": [
          "sfa",
          "eb2b"
        ],
        "route": "",
        "configuration": [
          {
            "name": "isAttendanceMandatory",
            "domainType": "attendance_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Make attendance mandatory for sales reps?",
              "config": "json",
              "description": "If Yes, reps must mark attendance before taking orders",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "attendanceStatusOption",
            "domainType": "attendance_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Attendance status options",
              "config": "custom",
              "description": {
                "attendanceStatusOption": " By default, only Present and Absent are shown. Use + Add status to include others"
              },
              "displayType": "table",
              "affectedValues": [
                "attendanceStatusOption"
              ]
            }
          },
          {
            "name": "requirePhotoForAttendance",
            "domainType": "attendance_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Require photo for attendance?",
              "description": "If Yes, reps must take a photo when marking attendance",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "attendanceLocationPopup",
            "domainType": "attendance_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Show attendance location popup before marking?",
              "config": "json",
              "displayType": "toggle",
              "description": "Prompt for location before attendance",
              "validations": {}
            }
          },
          {
            "name": "attendanceRange",
            "domainType": "attendance_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Attendance range for outlet (meters)",
              "config": "json",
              "description": "Range used specifically for attendance checks",
              "displayType": "textfield",
              "validations": {
                "textType": "number"
              },
              "dependsOn": {
                "attendanceLocationPopup": true
              }
            }
          },
          {
            "name": "blockOutletActivityOnLeave",
            "loaders": [],
            "domainType": "attendance_configuration",
            "uiSchema": {
              "question": "Block outlet activity on leave?",
              "description": "Block visit if attendance status indicates leave/absent",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "checkAttendanceOnMustDoAction",
            "domainType": "attendance_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Check attendance on Must Do Actions?",
              "description": "Determines whether to check attendance on must do action",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          }
        ]
      }
    ]
  },
  {
    "id": "Instore Executions",
    "icon": "stockInventoryConfigLogo",
    "subfeatures": [
      {
        "id": "Inventory",
        "domainMapping": {
          "clientconfig": [
            "store_inventory_configuration"
          ]
        },
        "supportedAppTypes": [
          "sfa",
          "eb2b"
        ],
        "route": "",
        "appType": "standard",
        "featureConfigName": "inventory",
        "configuration": [
          {
            "name": "inventoryTransactionVisibility",
            "domainType": "store_inventory_configuration",
            "loader": [],
            "uiSchema": {
              "question": "Show previous inventory & last date?",
              "description": "Show previous inventory quantity and the last recorded date on the inventory card.",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "copyCardData",
            "domainType": "store_inventory_configuration",
            "loader": [],
            "uiSchema": {
              "question": "Copy previous card data into new entry?",
              "description": "Pre-fill the new inventory form with values from the last entry.",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "stockInventoryFrequency",
            "domainType": "store_inventory_configuration",
            "loader": [],
            "uiSchema": {
              "question": "Allow user to submit Stock inventory more than once?",
              "description": "Whether to allow user to submit Stock inventory once or more.",
              "config": "json",
              "displayType": "textfield",
              "validations": {}
            }
          },
          {
            "name": "stockInventoryFields",
            "domainType": "store_inventory_configuration",
            "loader": [],
            "uiSchema": {
              "question": "Inventory form fields",
              "config": "custom",
              "displayType": "table",
              "validations": {},
              "affectedValues": [
                "stockInventoryFields"
              ]
            }
          }
        ]
      },
      {
        "id": "Return",
        "domainMapping": {
          "clientconfig": [
            "order_return_configuration"
          ]
        },
        "appType": "standard",
        "featureConfigName": "return",
        "supportedAppTypes": [
          "sfa",
          "eb2b"
        ],
        "route": "",
        "configuration": [
          {
            "name": "orderReturn",
            "domainType": "order_return_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Show return cart inside order cart?",
              "config": "json",
              "displayType": "toggle",
              "description": "If Yes, the Return cart is shown inside the Order cart.",
              "validations": {}
            }
          },
          {
            "name": "showAddMoreButton",
            "domainType": "order_return_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Show “Add more” button on return card?",
              "config": "json",
              "displayType": "toggle",
              "description": "If Yes, users can add more items to the return.",
              "validations": {}
            }
          },
          {
            "name": "displayProductMaster",
            "domainType": "order_return_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Display full product catalogue in returns?",
              "config": "json",
              "displayType": "toggle",
              "description": "If Yes, show all products in the return flow.",
              "validations": {}
            }
          },
          {
            "name": "orderReturnFields",
            "domainType": "order_return_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Return form fields",
              "config": "custom",
              "displayType": "table",
              "affectedValues": [
                "orderReturnFields"
              ]
            }
          },
          {
            "name": "orderReturnReason",
            "domainType": "order_return_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Return reasons (list)",
              "config": "custom",
              "displayType": "table",
              "affectedValues": [
                "orderReturnReason"
              ]
            }
          },
          {
            "name": "submitReturnSalesData",
            "domainType": "order_return_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Submit return sales data?",
              "config": "json",
              "displayType": "toggle",
              "description": "If Yes, include sales data when submitting returns.",
              "validations": {}
            }
          },
          {
            "name": "submitSalesReturnWORefNumApp",
            "domainType": "order_return_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Allow submit without reference number (app)?",
              "config": "json",
              "displayType": "toggle",
              "description": "If Yes, allow submitting a sales return without a reference number.",
              "validations": {}
            }
          }
        ]
      }
    ]
  },
  {
    "id": "Incentive",
    "icon": "incentiveConfigLogo",
    "subfeatures": [
      {
        "id": "IntelligentIncentive",
        "domainMapping": {
          "clientconfig": [
            "incentive_configuration"
          ]
        },
        "appType": "standard",
        "featureConfigName": "intelligentincentive",
        "supportedAppTypes": [
          "sfa",
          "eb2b"
        ],
        "route": "",
        "configuration": [
          {
            "name": "incentiveTabConfig",
            "domainType": "incentive_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Incentive Tabs",
              "config": "custom",
              "displayType": "checkbox",
              "validations": {},
              "affectedValues": [
                "incentiveTabConfig"
              ],
              "description": {
                "incentiveTabConfig": "Choose which tabs appear in the Incentive screen"
              }
            }
          },
          {
            "name": "ruleMapping",
            "domainType": "incentive_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Incentive tasks (display)",
              "config": "custom",
              "displayType": "table",
              "description": {
                "ruleMapping": "Controls how incentive tasks appear (icon, colors, order). Higher priority = shown first"
              },
              "affectedValues": [
                "ruleMapping"
              ]
            }
          },
          {
            "name": "incentiveLiveUpdate",
            "domainType": "incentive_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Enable live updates?",
              "config": "json",
              "displayType": "toggle",
              "description": "If Yes, incentive data refreshes automatically in the app."
            }
          },
          {
            "name": "openLeaderboardOnSfaActionTab",
            "domainType": "incentive_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Open Leaderboard from SFA Action tab?",
              "config": "json",
              "displayType": "toggle",
              "description": "If Yes, show the Leaderboard entry in the SFA Action tab."
            }
          },
          {
            "name": "leaderboardDesignation",
            "domainType": "incentive_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Default leaderboard designation",
              "config": "json",
              "displayType": "textbox",
              "description": "Designation to load by default on the Leaderboard (e.g., dse)."
            }
          },
          {
            "name": "incentiveFaq",
            "domainType": "incentive_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Incentive FAQs",
              "config": "custom",
              "displayType": "table",
              "description": {
                "incentiveFaq": "User can share FAQs if enabled"
              },
              "affectedValues": [
                "incentiveFaq"
              ]
            }
          },
          {
            "name": "showIncentivePopup",
            "domainType": "incentive_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Show Incentive popups?",
              "config": "json",
              "displayType": "toggle",
              "description": "If Yes, show pop up of left incentive points."
            }
          },
          {
            "name": "incentiveDuration",
            "domainType": "incentive_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Incentive Duration?",
              "config": "json",
              "displayType": "select",
              "description": "Show incentive duration.",
              "validations": {
                "options": [
                  "MONTH",
                  "PERIOD",
                  "WEEKLY"
                ]
              }
            }
          },
          {
            "name": "incentiveCalculationType",
            "domainType": "incentive_configuration",
            "loaders": [],
            "uiSchema": {
              "question": "Select Incentive Calculation type",
              "config": "json",
              "displayType": "select",
              "description": "User can select if incentive is to be calculated on sales or order.",
              "validations": {
                "options": [
                  "SALES",
                  "ORDER"
                ]
              }
            }
          }
        ]
      }
    ]
  },
  {
    "id": "portal configuration",
    "icon": "default",
    "subfeatures": [
      {
        "id": "Portal ",
        "featureConfigName": "portal",
        "route": "",
        "domainMapping": {
          "clientconfig": [
            "portal_configuration"
          ]
        },
        "appType": "standard",
        "supportedAppTypes": [
          "sfa",
          "eb2b"
        ],
        "configuration": [
          {
            "name": "rolesWisePWACredentials",
            "domainType": "portal_configuration",
            "section": "",
            "loaders": [],
            "uiSchema": {
              "question": "this currently publicly shows the password of default users ",
              "config": "json",
              "description": "this currently publicly shows the password of default users , which is incorrect and needs to be changed asap , ........................................",
              "displayType": "textfield",
              "vailidations": {},
              "dependsOn": {}
            }
          }
        ]
      }
    ]
  },
  {
    "id": "client specific something ",
    "icon": "default",
    "subfeatures": [
      {
        "id": "first discussed feature ",
        "featureConfigName": "first discussed feature ",
        "route": "",
        "domainMapping": {
          "clientconfig": [
            "order_configuration"
          ]
        },
        "appType": "standard",
        "supportedAppTypes": [
          "sfa"
        ],
        "configuration": [
          {
            "name": "moq",
            "domainType": "order_configuration",
            "section": "",
            "loaders": [],
            "uiSchema": {
              "question": "this specifies the moq of a order value ",
              "config": "json",
              "description": "this specifies the moq of a order value ,this specifies the moq of a order value ,this specifies the moq of a order value this specifies the moq of a order value ,this specifies the moq of a order value ",
              "displayType": "textfield",
              "vailidations": {},
              "dependsOn": {}
            }
          }
        ]
      }
    ]
  },
  {
    "id": "Primary",
    "icon": "uiThemeConfigLogo",
    "subfeatures": [
      {
        "id": "Order Edit",
        "featureConfigName": "replOrderEdit",
        "serviceId": "replEditingService",
        "appType": "standard",
        "supportedAppTypes": [
          "sfa",
          "eb2b",
          "dms"
        ],
        "configuration": [
          {
            "name": "distributor",
            "section": "Repl Order Edit Configuration",
            "uiSchema": {
              "question": "Select Distributor Filters",
              "config": "custom",
              "affectedValues": [
                "distributor"
              ],
              "description": {
                "distributor": "Filter for selecting distributor"
              }
            }
          },
          {
            "name": "type",
            "section": "Repl Order Edit Configuration",
            "uiSchema": {
              "question": "Please select capping to be applied based on",
              "config": "json",
              "displayType": "radio",
              "validations": {
                "options": [
                  {
                    "label": "Order Amount Based",
                    "value": "amount"
                  },
                  {
                    "label": "Order Quantity Based",
                    "value": "quantity"
                  }
                ],
                "required": true
              }
            }
          },
          {
            "name": "arsPercentageBound",
            "section": "Repl Order Edit Configuration",
            "uiSchema": {
              "question": "Set Percentage(%) of Upper/Lower Capping Allowed",
              "config": "json",
              "displayType": "textfield",
              "validations": {
                "suffix": "%",
                "width": "37%",
                "textType": "number",
                "regex": "^(?:100|[1-9][0-9]?)$",
                "required": true,
                "minimumValue": 1,
                "maximumValue": 100
              }
            }
          }
        ]
      },
      {
        "id": "Manual Editing",
        "featureConfigName": "manualPrimaryOrderDay",
        "serviceId": "ManualPrimaryOrderDayService",
        "appType": "standard",
        "supportedAppTypes": [
          "sfa",
          "eb2b",
          "dms"
        ],
        "configuration": [
          {
            "name": "distributor",
            "section": "Manual Primary Editing Configuration",
            "uiSchema": {
              "question": "Select Filters",
              "config": "custom",
              "affectedValues": [
                "distributor"
              ],
              "description": {
                "distributor": "Filter for selecting distributor"
              }
            }
          },
          {
            "name": "weekdays",
            "section": "Manual Primary Editing Configuration",
            "uiSchema": {
              "question": "Select the allowed Number of Days for invoice Editing",
              "config": "custom",
              "displayType": "multselect",
              "affectedValues": [
                "manualPrimaryOrderDays"
              ]
            }
          }
        ]
      }
    ]
  },
  {
    "id": "Secondary",
    "icon": "uiThemeConfigLogo",
    "subfeatures": [
      {
        "id": "Invoice Editing",
        "featureConfigName": "invoiceEditing",
        "serviceId": "invoiceEditingService",
        "appType": "standard",
        "supportedAppTypes": [
          "sfa",
          "eb2b",
          "dms"
        ],
        "configuration": [
          {
            "name": "channel",
            "section": "Invoice Editing Configuration",
            "uiSchema": {
              "question": "Select Channel Filters",
              "config": "custom",
              "affectedValues": [
                "channel"
              ],
              "description": {
                "channel": "Filter for selecting channel"
              }
            }
          },
          {
            "name": "allowedNoOfDays",
            "section": "Invoice Editing Configuration",
            "uiSchema": {
              "question": "Select the allowed Number of Days for invoice Editing",
              "config": "json",
              "displayType": "textfield",
              "validations": {
                "suffix": "days",
                "width": "23%",
                "textType": "number",
                "regex": "^(?:100|[1-9]?[0-9])$",
                "required": true,
                "minimumValue": 0
              }
            }
          }
        ]
      }
    ]
  },
  {
    "id": "SFAI",
    "icon": "uiThemeConfigLogo",
    "subfeatures": [
      {
        "id": "GeoFencing",
        "featureConfigName": "geoFencingEdit",
        "serviceId": "geoFencingService",
        "appType": "standard",
        "supportedAppTypes": [
          "sfa",
          "eb2b",
          "dms"
        ],
        "configuration": [
          {
            "name": "distributor",
            "section": "Geo Fencing Configuration",
            "uiSchema": {
              "question": "Select Filters",
              "config": "custom",
              "displayType": "select",
              "affectedValues": [
                "distributor"
              ]
            }
          },
          {
            "name": "salesmen",
            "section": "Geo Fencing Configuration",
            "uiSchema": {
              "question": "Select salesman",
              "config": "custom",
              "affectedValues": [
                "salesman"
              ]
            }
          },
          {
            "name": "enable",
            "section": "Geo Fencing Configuration",
            "uiSchema": {
              "question": "Select if Geo-Fencing needs to be enabled or disabled",
              "config": "json",
              "displayType": "radio",
              "validations": {
                "options": [
                  {
                    "label": "Enable",
                    "value": "true"
                  },
                  {
                    "label": "Disable",
                    "value": "false"
                  }
                ],
                "required": true
              }
            }
          }
        ]
      }
    ]
  }
]
// export const featureConfiguration = [
//      {
//         "id": "App essentials",
//         "isDeveloped": true,
//         "icon": "projectConfigLogo",
//         "description": " Setup the foundations of your app like timezone, dial code, currency & support no.",
//         "isActive": true,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "displayTemplateTwo": true,
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "appType": "standard",
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ],
//         "subfeatures":[
//             {
//         "id": "Project",
//         "isDeveloped": true,
//         "featureConfigName": "project",
//         "isActive": true,
//         "isSelected": true,
//         "isMandatory": true,
//         "domainMapping":{
//             "clientconfig":["project_configuration","customer_configuration"]
//         },
//         "hintImage": "kpiHintImage",
//         "displayTemplateTwo": true,
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "appType": "standard",
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ],
//         "configuration":[
//   {
//     "name": "countryCode",
//     "value": "AM",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter country code",
//       "config": "custom",
//       "displayType": "select",
//       "editable": true,
//       "validations": [],
    
//     }
//   },
//   {
//     "name": "dialCode",
//     "value": "374",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter dial code",
//       "config": "custom",
//       "displayType": "select",
//       "editable": false,
//       "validations": []
//     }
//   },
//   {
//     "name": "clientTimeZone",
//     "value": "Asia/Yerevan",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Select client timezone",
//       "config": "custom",
//       "displayType": "select",
//       "editable": true,
//       "validations": []
//     }
//   },
//   {
//     "name": "currencySymbol",
//     "value": "֏",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter currency symbol",
//       "config": "custom",
//       "displayType": "select",
//       "editable": true,
//       "validations": []
//     }
//   },
//   {
//     "name": "currency",
//     "value": "₹",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter currency",
//       "config": "custom",
//       "displayType": "textField",
//       "editable": false,
//       "validations": []
//     }
//   },
//   {
//     "name": "supportNumber",
//     "value": "123123123118",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter support number",
//       "config": "json",
//       "displayType": "textField",
//       "editable": true,
//       "validations": ["^.{10,15}$"]
//     }
//   },
//   {
//     "name": "externalAppDeepLink",
//     "value": "test.com",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter deep link",
//       "config": "json",
//       "displayType": "textField",
//       "editable": true,
//       "validations": []
//     }
//   },
//   {
//     "name": "chatGptEnabled",
//     "value": true,
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "boolean",
//       "question": "Enable ChatGPT?",
//       "config": "json",
//       "displayType": "checkbox",
//       "editable": true,
//       "validations": []
//     }
//   },
//   {
//     "name": "clientHeaderLogoHeight",
//     "value": "",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter header logo height",
//       "config": "json",
//       "displayType": "textField",
//       "editable": true,
//       "validations": ["^[1-9]\\d*$"]
//     }
//   }
// ]
       
// },
//     {
//         "id": "ProjectNonStandard",
//         "isDeveloped": true,
//         "featureConfigName": "project",
//          "domainMapping":{
//            "clientconfig":["project_configuration","customer_configuration"]
//         },
//         "isActive": true,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "displayTemplateTwo": true,
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "appType": "nonstandard",
//         "label": "Project",
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ],
//           "configuration":[
//   {
//     "name": "countryCode",
//     "value": "AM",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter country code",
//       "config": "custom",
//       "displayType": "select",
//       "editable": true,
//       "validations": [],
    
//     }
//   },
//   {
//     "name": "dialCode",
//     "value": "374",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter dial code",
//       "config": "custom",
//       "displayType": "select",
//       "editable": false,
//       "validations": []
//     }
//   },
//   {
//     "name": "clientTimeZone",
//     "value": "Asia/Yerevan",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Select client timezone",
//       "config": "custom",
//       "displayType": "select",
//       "editable": true,
//       "validations": []
//     }
//   },
//   {
//     "name": "currencySymbol",
//     "value": "֏",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter currency symbol",
//       "config": "custom",
//       "displayType": "select",
//       "editable": true,
//       "validations": []
//     }
//   },
//   {
//     "name": "currency",
//     "value": "₹",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter currency",
//       "config": "custom",
//       "displayType": "textField",
//       "editable": false,
//       "validations": []
//     }
//   },
//   {
//     "name": "supportNumber",
//     "value": "123123123118",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter support number",
//       "config": "json",
//       "displayType": "textField",
//       "editable": true,
//       "validations": ["^.{10,15}$"]
//     }
//   },
//   {
//     "name": "externalAppDeepLink",
//     "value": "test.com",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter deep link",
//       "config": "json",
//       "displayType": "textField",
//       "editable": true,
//       "validations": []
//     }
//   },
//   {
//     "name": "chatGptEnabled",
//     "value": true,
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "boolean",
//       "question": "Enable ChatGPT?",
//       "config": "json",
//       "displayType": "checkbox",
//       "editable": true,
//       "validations": []
//     }
//   },
//   {
//     "name": "clientHeaderLogoHeight",
//     "value": "",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter header logo height",
//       "config": "json",
//       "displayType": "textField",
//       "editable": true,
//       "validations": ["^[1-9]\\d*$"]
//     }
//   }
// ]
//     },
//     {
//         "id": "AppNonStandard",
//         "isDeveloped": true,
//         "icon": "uiThemeConfigLogo",
//         "featureConfigName": "app",
//         "isActive": false,
//          "domainMapping":{
//             "clientconfig":["app_configuration","theme_configuration"]
//         },
//         "isSelected": true,
//         "isMandatory": true,
       
//         "hintImage": "kpiHintImage",
//         "displayTemplateTwo": true,
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "appType": "nonstandard",
//         "label": "App",
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ],
//         "configurations":[

//         ],   
//     },
//     {
//         "id": "UI and Theme",
//         "isDeveloped": true,
//         "featureConfigName": "uiandtheme",
//         "icon": "uiThemeConfigLogo",
//         "domainMapping":{
//             "clientconfig":["app_configuration","theme_configuration","ui_and_theme_configuration"]
//         },
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "displayTemplateTwo": true,
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "appType": "standard",
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ],
//         "configurations":[
//   {
//     "name": "clientHeaderLogo",
//     "value": "",
//     "domainType": "ui_and_theme_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Upload client header logo",
//       "config": "json",
//       "displayType": "image",
//       "editable": true,
//       "validations": []
//     }
//   },
//   {
//     "name": "clientHeaderLogoHeight",
//     "value": 40,
//     "domainType": "ui_and_theme_configuration",
//     "uiSchema": {
//       "type": "number",
//       "question": "Enter logo height (px)",
//       "config": "json",
//       "displayType": "textField",
//       "editable": true,
//       "validations": ["^[1-9]\\d*$"]
//     }
//   },
//   {
//     "name": "themeColor",
//     "value": "227c9d",
//     "domainType":"ui_and_theme_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Select theme color",
//       "config": "json",
//       "displayType": "colorInput",
//       "editable": true,
//       "validations": ["^#?([0-9a-fA-F]{6})$"]
//     }
//   }
// ]     
//     },

//         ]
//     },
    
//     {
//         "id": "Multi Language Interface",
//         "icon": "bannerConfigLogo",
//         "description": "Displays promotional banners throughout the application.",
//         "featureConfigName": "multilanguageinterface",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Login",
//         "isDeveloped": true,
//         "icon": "loginConfigLogo",
//         "description": "Manage the login config",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "login",
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//         "subfeatures":[
            
//         ]
//     },
//     {
//         "id": "Password",
//         "isDeveloped": true,
//         "icon": "loginConfigLogo",
//         "description": "Manage the password config",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "password",
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Recommendation",
//         "icon": "recommendationConfigLogo",
//         "description": "Provides recommendations based on user behavior.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "recomendationImage",
//         "featureConfigName": "recommendation",
//         "addTemplate": true,
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Must Do Action",
//         "isDeveloped": true,
//         "icon": "teleOrderConfigLogo",
//         "description": "Manage the sequence and messaging of must do task.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "teleOrderImage",
//         "featureConfigName": "mustdoaction",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "KPI Review",
//         "isDeveloped": true,
//         "icon": "kpiConfigLogo",
//         "description": "Select and modify KPIs you want to show to your Sales team.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "kpi",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Attendance",
//         "icon": "attendanceConfigLogo",
//         "description": "Manages user attendance records.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "attendance",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Outlet Tile",
//         "icon": "outletTaskTileConfigLogo",
//         "description": "Displays tasks associated with outlets in a tile format.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "outlettile",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Outlet Profile",
//         "icon": "outletProfileConfigLogo",
//         "description": "Shows detailed profiles of outlets.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "outletprofile",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Search Functionality",
//         "icon": "checkoutConfigLogo",
//         "description": "Manage what the user sees before order submission.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "searchfunctionality",
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Catalogue",
//         "isDeveloped": true,
//         "icon": "catalogueConfigLogo",
//         "description": "Manage the product catalogue to make the ordering process more efficient.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "featureConfigName": "catalogue",
//         "hintImage": "kpiHintImage",
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Visit Order",
//         "icon": "visitOrderConfigLogo",
//         "description": "Manages orders related to user visits.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "visitorder",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Cart",
//         "isDeveloped": true,
//         "icon": "cartConfigLogo",
//         "description": "Manage the cart before moving to order submission.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "cart",
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "One Click Order",
//         "icon": "oneClickOrderConfigLogo",
//         "description": "Enables users to place orders with a single click.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "oneclickorder",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Remote Order",
//         "icon": "remoteOrderConfigLogo",
//         "description": "Handles orders placed remotely by users.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "remoteorder",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Tele Order",
//         "icon": "teleOrderConfigLogo",
//         "description": "Handles orders placed via telephone.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "teleOrderImage",
//         "featureConfigName": "teleOrder",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "app_layout_configuration",
//                 "domainValues": [
//                     {
//                         "name": "outletTileOptions",
//                         "type": "List",
//                         "value": [
//                             {
//                                 "id": "Tele Order",
//                                 "svgPath": "assets/svg/teleOrder.svg"
//                             },
//                             {
//                                 "id": "Remote Order",
//                                 "svgPath": "assets/svg/myRemoteOrder.svg"
//                             },
//                             {
//                                 "id": "Visit Order",
//                                 "svgPath": "assets/svg/visitOrder.svg"
//                             }
//                         ],
//                         "customHandler": {
//                             "added": {
//                                 "function": "appendInTileOptions",
//                                 "customValue": [
//                                     {
//                                         "id": "Tele Order",
//                                         "svgPath": "assets/svg/teleOrder.svg"
//                                     }
//                                 ]
//                             },
//                             "removed": {
//                                 "function": "removeFromTileOptions",
//                                 "identificationField": "id",
//                                 "customValue": [
//                                     {
//                                         "id": "Tele Order",
//                                         "svgPath": "assets/svg/teleOrder.svg"
//                                     }
//                                 ]
//                             }
//                         },
//                         "docUrl": "",
//                         "description": "Outlet tile options",
//                         "possibleVals": []
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Order Summary",
//         "isDeveloped": true,
//         "icon": "checkoutConfigLogo",
//         "description": "Manage what the user sees before order submission.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "ordersummary",
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Order Feedback",
//         "icon": "orderFeedbackConfigLogo",
//         "description": "Gathers feedback from users about their orders.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "orderfeedback",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Order Tracking",
//         "isDeveloped": true,
//         "icon": "orderTrackingConfigLogo",
//         "description": "Manage how the user can review  and track the orders.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "ordertracking",
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Store In/Out",
//         "icon": "storeInOutConfigLogo",
//         "description": "Tracks inventory for store in and out operations.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "storeinout",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Return",
//         "icon": "stockInventoryConfigLogo",
//         "description": "Manages and tracks stock inventory levels.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "stockInventoryImage",
//         "featureConfigName": "stockReturn",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "app_layout_configuration",
//                 "domainValues": [
//                     {
//                         "name": "outletActivityTabs",
//                         "type": "list",
//                         "value": [
//                             {
//                                 "id": "storeReturn",
//                                 "label": "STOCK RETURN",
//                                 "iconPath": "assets/svg/stock_returns.svg",
//                                 "isDefault": true,
//                                 "themeColor": "#7f7398",
//                                 "storeInRequired": ""
//                             }
//                         ],
//                         "description": "temp",
//                         "defaultValue": "[]",
//                         "possibleVals": [
//                             []
//                         ],
//                         "customHandler": {
//                             "added": {
//                                 "function": "updateTabList",
//                                 "identificationField": "id"
//                             },
//                             "removed": {
//                                 "function": "removeTab",
//                                 "identificationField": "id"
//                             }
//                         }
//                     }
//                 ]
//             },
//             {
//                 "domainType": "order_return_configuration",
//                 "domainValues": [
//                     {
//                         "name": "orderReturnFields",
//                         "type": "List",
//                         "value": [
//                             {
//                                 "id": "returnReason",
//                                 "type": "dropDown",
//                                 "label": "Reason",
//                                 "validation": {}
//                             },
//                             {
//                                 "id": "returnQtyPC",
//                                 "type": "textField",
//                                 "label": "Return Qty (PC)",
//                                 "validation": {}
//                             }
//                         ]
//                     },
//                     {
//                         "name": "orderReturnReason",
//                         "type": "List",
//                         "value": [
//                             {
//                                 "id": "1",
//                                 "reason": "Maximum freshness"
//                             },
//                             {
//                                 "id": "9",
//                                 "reason": "Striked"
//                             },
//                             {
//                                 "id": "10",
//                                 "reason": "Damaged label"
//                             },
//                             {
//                                 "id": "11",
//                                 "reason": "Dirty"
//                             },
//                             {
//                                 "id": "12",
//                                 "reason": "Closed bursts"
//                             },
//                             {
//                                 "id": "13",
//                                 "reason": "Empty - Bottle base cracks"
//                             },
//                             {
//                                 "id": "14",
//                                 "reason": "Low level"
//                             },
//                             {
//                                 "id": "15",
//                                 "reason": "Bottle cap unclosed"
//                             },
//                             {
//                                 "id": "16",
//                                 "reason": "Internal dirt/Foreign Matter - Closed"
//                             },
//                             {
//                                 "id": "17",
//                                 "reason": "Soft Bottle Closed"
//                             },
//                             {
//                                 "id": "18",
//                                 "reason": "Bottle Deformation"
//                             },
//                             {
//                                 "id": "19",
//                                 "reason": "Stress Leakage Shoulders / Finish"
//                             }
//                         ],
//                         "docUrl": "",
//                         "description": "return reason in stock return",
//                         "possibleVals": []
//                     },
//                     {
//                         "name": "orderReturn",
//                         "type": "boolean",
//                         "value": true,
//                         "docUrl": "",
//                         "description": "Whether to show return cart page inside order cart page",
//                         "possibleVals": [
//                             true,
//                             false
//                         ]
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Inventory",
//         "icon": "stockInventoryConfigLogo",
//         "description": "Manages and tracks stock inventory levels.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "stockInventoryImage",
//         "featureConfigName": "stockInventory",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "app_layout_configuration",
//                 "domainValues": [
//                     {
//                         "name": "outletActivityTabs",
//                         "type": "list",
//                         "value": [
//                             {
//                                 "id": "storeInventory",
//                                 "label": "STOCK INVENTORY",
//                                 "iconPath": "assets/svg/store_inventory.svg",
//                                 "isDefault": true,
//                                 "themeColor": "#32a785",
//                                 "storeInRequired": ""
//                             }
//                         ],
//                         "description": "temp",
//                         "defaultValue": "[]",
//                         "possibleVals": [
//                             []
//                         ],
//                         "customHandler": {
//                             "added": {
//                                 "function": "updateTabList",
//                                 "identificationField": "id"
//                             },
//                             "removed": {
//                                 "function": "removeTab",
//                                 "identificationField": "id"
//                             }
//                         }
//                     }
//                 ]
//             },
//             {
//                 "domainType": "store_inventory_configuration",
//                 "domainValues": [
//                     {
//                         "name": "inventoryTransactionVisibility",
//                         "type": "boolean",
//                         "value": true,
//                         "description": "Whether to show previous inventory qty and  last inventory date in store inventory card",
//                         "possibleVals": [
//                             true,
//                             false
//                         ]
//                     },
//                     {
//                         "name": "copyCardData",
//                         "type": "boolean",
//                         "value": true,
//                         "description": "Whether to copy previous inventory card data or not",
//                         "possibleVals": [
//                             true,
//                             false
//                         ]
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Merchandising",
//         "icon": "merchandisingConfigLogo",
//         "description": "Handles merchandising strategies and displays.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "merchandisingImage",
//         "featureConfigName": "merchandising",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "app_layout_configuration",
//                 "domainValues": [
//                     {
//                         "name": "outletActivityTabs",
//                         "type": "list",
//                         "value": [
//                             {
//                                 "id": "merchandising",
//                                 "label": "MERCHANDISING",
//                                 "iconPath": "assets/svg/merchandising.svg",
//                                 "isDefault": false,
//                                 "themeColor": "#767bfe",
//                                 "storeInRequired": ""
//                             }
//                         ],
//                         "description": "temp",
//                         "defaultValue": "[]",
//                         "possibleVals": [
//                             []
//                         ],
//                         "customHandler": {
//                             "added": {
//                                 "function": "updateTabList",
//                                 "identificationField": "id"
//                             },
//                             "removed": {
//                                 "function": "removeTab",
//                                 "identificationField": "id"
//                             }
//                         }
//                     }
//                 ]
//             },
//             {
//                 "domainType": "app_options_configuration",
//                 "domainValues": [
//                     {
//                         "name": "merchandisingOption",
//                         "type": "list",
//                         "value": [
//                             "Merchandising 1",
//                             "Merchandising 2",
//                             "Merchandising 3"
//                         ],
//                         "description": "temp",
//                         "defaultValue": [],
//                         "possibleVals": [
//                             []
//                         ]
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Competition Tracking",
//         "icon": "competitionTrackingConfigLogo",
//         "description": "Tracks competitions and their results.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "competetionTrackingImage",
//         "featureConfigName": "competitionTracking",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "app_layout_configuration",
//                 "domainValues": [
//                     {
//                         "name": "outletActivityTabs",
//                         "type": "list",
//                         "value": [
//                             {
//                                 "id": "competitionTracking",
//                                 "label": "COMPETITION TRACKING",
//                                 "iconPath": "assets/svg/competition_tracking.svg",
//                                 "isDefault": true,
//                                 "themeColor": "#e1ad01",
//                                 "storeInRequired": ""
//                             }
//                         ],
//                         "description": "temp",
//                         "defaultValue": "[]",
//                         "possibleVals": [
//                             []
//                         ],
//                         "customHandler": {
//                             "added": {
//                                 "function": "updateTabList",
//                                 "identificationField": "id"
//                             },
//                             "removed": {
//                                 "function": "removeTab",
//                                 "identificationField": "id"
//                             }
//                         }
//                     }
//                 ]
//             },
//             {
//                 "domainType": "app_options_configuration",
//                 "domainValues": [
//                     {
//                         "name": "competitorOption",
//                         "type": "list",
//                         "value": [
//                             "Competitor 1",
//                             "Competitor 2",
//                             "Competitor 3"
//                         ],
//                         "description": "temp",
//                         "defaultValue": [],
//                         "possibleVals": [
//                             []
//                         ]
//                     },
//                     {
//                         "name": "activityOption",
//                         "type": "list",
//                         "value": [
//                             "Activity 1",
//                             "Activity 2",
//                             "Activity 3"
//                         ],
//                         "description": "temp",
//                         "defaultValue": [],
//                         "possibleVals": [
//                             []
//                         ]
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Basket",
//         "icon": "bannerConfigLogo",
//         "description": "Displays promotional banners throughout the application.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "basket",
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Profile",
//         "icon": "bannerConfigLogo",
//         "description": "Displays promotional banners throughout the application.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "profile",
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Bucket",
//         "icon": "bannerConfigLogo",
//         "description": "Displays promotional banners throughout the application.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "bucket",
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Banner",
//         "icon": "bannerConfigLogo",
//         "description": "Displays promotional banners throughout the application.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "banner",
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Scheme Module",
//         "icon": "checkoutConfigLogo",
//         "description": "Manage what the user sees before order submission.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "schemeproduct",
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Order Edit/Cancellation",
//         "icon": "checkoutConfigLogo",
//         "description": "Manage what the user sees before order submission.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "ordercancellation",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "order_configuration",
//                 "domainValues": [
//                     {
//                         "name": "orderCancellation",
//                         "type": "boolean",
//                         "value": true,
//                         "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
//                         "description": "To allow order cancellation",
//                         "defaultValue": false,
//                         "possibleVals": [
//                             true,
//                             false
//                         ]
//                     },
//                     {
//                         "name": "orderCancellationCardColor",
//                         "type": "string",
//                         "value": "#2bbbad",
//                         "docUrl": "",
//                         "description": "order cancellation card color",
//                         "defaultValue": "#2bbbad",
//                         "possibleVals": [
//                             "#2bbbad"
//                         ]
//                     },
//                     {
//                         "name": "orderCancellationPeriod",
//                         "type": "number",
//                         "value": 180,
//                         "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
//                         "description": "Time (in secs) within which the order can be cancelled",
//                         "defaultValue": 0,
//                         "possibleVals": []
//                     },
//                     {
//                         "name": "orderCancellationReasons",
//                         "type": "list",
//                         "value": [
//                             "I have ordered the products through Salesman.",
//                             "I ordered wrong product(s).",
//                             "I ordered wrong quantity.",
//                             "I got better rates elsewhere.",
//                             "Other reasons."
//                         ],
//                         "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
//                         "description": "Reasons for order cancellation. We'll restrict that 5 reasons can be added at max.",
//                         "defaultValue": [
//                             "I have ordered the products through Salesman.",
//                             "I ordered wrong product(s).",
//                             "I ordered wrong quantity.",
//                             "I got better rates elsewhere.",
//                             "Other reasons."
//                         ],
//                         "possibleVals": []
//                     },
//                     {
//                         "name": "orderCancellationDisclaimer",
//                         "type": "String",
//                         "value": "Before you cancel, please let us know the reason to help us improve our services",
//                         "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
//                         "description": "Order Cancel Disclaimer",
//                         "defaultValue": "Before you cancel, please let us know the reason to help us improve our services",
//                         "possibleVals": []
//                     },
//                     {
//                         "name": "orderCancellationSummaryDisclaimer",
//                         "type": "String",
//                         "value": "Hi there! I have cancelled your order as per request.",
//                         "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
//                         "description": "Order Cancel Disclaimer",
//                         "defaultValue": "Hi there! I have cancelled your order as per request.",
//                         "possibleVals": []
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Order Ledger",
//         "icon": "checkoutConfigLogo",
//         "description": "Manage what the user sees before order submission.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "orderledger",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "order_configuration",
//                 "domainValues": [
//                     {
//                         "name": "orderSourceVisibility",
//                         "type": "boolean",
//                         "value": true,
//                         "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
//                         "description": "To order source visible.",
//                         "defaultValue": true,
//                         "possibleVals": [
//                             true,
//                             false
//                         ]
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Invoice Ledger",
//         "icon": "checkoutConfigLogo",
//         "description": "Manage what the user sees before order submission.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "invoice",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "app_layout_configuration",
//                 "domainValues": [
//                     {
//                         "name": "morePageWidget",
//                         "type": "list",
//                         "value": [
//                             {
//                                 "name": "InvoiceTracking",
//                                 "type": "moreOptions",
//                                 "image": "assets/svg/Invoice.svg",
//                                 "label": "Invoice Details"
//                             }
//                         ],
//                         "customHandler": {
//                             "added": {
//                                 "function": "updateTabList",
//                                 "identificationField": "name"
//                             },
//                             "removed": {
//                                 "function": "removeTab",
//                                 "identificationField": "name"
//                             }
//                         }
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Purchase Summary",
//         "icon": "checkoutConfigLogo",
//         "description": "Manage what the user sees before order submission.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "purchasesummary",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "app_layout_configuration",
//                 "domainValues": [
//                     {
//                         "name": "morePageWidget",
//                         "type": "list",
//                         "value": [
//                             {
//                                 "name": "Purchase Summary",
//                                 "type": "moreOptions",
//                                 "image": "assets/svg/purchase_summary.svg",
//                                 "label": "Purchase Summary"
//                             }
//                         ],
//                         "customHandler": {
//                             "added": {
//                                 "function": "updateTabList",
//                                 "identificationField": "name"
//                             },
//                             "removed": {
//                                 "function": "removeTab",
//                                 "identificationField": "name"
//                             }
//                         }
//                     }
//                 ]
//             },
//             {
//                 "domainType": "app_options_configuration",
//                 "domainValues": [
//                     {
//                         "name": "purchaseSummaryDataSorting",
//                         "type": "boolean",
//                         "value": true,
//                         "docUrl": "",
//                         "description": "Purchase summary data sorting",
//                         "possibleVals": [
//                             "true",
//                             "false"
//                         ]
//                     },
//                     {
//                         "name": "purchaseSummaryHeaderConfig",
//                         "type": "list",
//                         "value": [
//                             {
//                                 "id": "bill_value",
//                                 "label": "Bill Value",
//                                 "barChart": true,
//                                 "imagePath": "bill_value.svg",
//                                 "lineChart": false,
//                                 "currencyIcon": true,
//                                 "showTrendChart": true,
//                                 "chartDisclaimer": true,
//                                 "decimalConvert": true
//                             },
//                             {
//                                 "id": "total_earning",
//                                 "label": "Total Earning",
//                                 "barChart": true,
//                                 "imagePath": "total_earning.svg",
//                                 "lineChart": false,
//                                 "currencyIcon": true,
//                                 "showTrendChart": true,
//                                 "chartDisclaimer": true,
//                                 "decimalConvert": true
//                             },
//                             {
//                                 "id": "number_of_bills",
//                                 "label": "Number of Bills",
//                                 "barChart": false,
//                                 "imagePath": "number_of_bills.svg",
//                                 "lineChart": true,
//                                 "currencyIcon": false,
//                                 "showTrendChart": true,
//                                 "chartDisclaimer": true,
//                                 "showingTooltipOnSpots": [],
//                                 "decimalConvert": false
//                             },
//                             {
//                                 "id": "number_of_packs",
//                                 "label": "Packs Purchased",
//                                 "barChart": false,
//                                 "imagePath": "pack_purchased.svg",
//                                 "lineChart": true,
//                                 "currencyIcon": false,
//                                 "showTrendChart": true,
//                                 "chartDisclaimer": true,
//                                 "showingTooltipOnSpots": [],
//                                 "decimalConvert": false
//                             },
//                             {
//                                 "id": "total_quantity",
//                                 "label": "Total Quantity",
//                                 "barChart": false,
//                                 "imagePath": "total_quqntity.svg",
//                                 "lineChart": false,
//                                 "currencyIcon": false,
//                                 "QtyDisplayList": [
//                                     {
//                                         "key": "total_case_quantity",
//                                         "label": "cs"
//                                     },
//                                     {
//                                         "key": "total_piece_quantity",
//                                         "label": "pcs"
//                                     }
//                                 ],
//                                 "showTrendChart": false,
//                                 "chartDisclaimer": false,
//                                 "decimalConvert": false
//                             }
//                         ],
//                         "description": "Purchase Tiles",
//                         "possibleVals": [
//                             "true",
//                             "false"
//                         ]
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Support",
//         "icon": "supportConfigLogo",
//         "description": "Provides support options for users.",
//         "featureConfigName": "support",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Order Status Push Notification",
//         "icon": "checkoutConfigLogo",
//         "description": "Manage what the user sees before order submission.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "featureConfigName": "orderstatuspushnotification",
//         "hintImage": "kpiHintImage",
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Locate Me",
//         "icon": "checkoutConfigLogo",
//         "description": "Manage what the user sees before order submission.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "locateme",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "app_layout_configuration",
//                 "domainValues": [
//                     {
//                         "name": "morePageWidget",
//                         "type": "list",
//                         "value": [
//                             {
//                                 "name": "locateMe",
//                                 "type": "moreOptions",
//                                 "image": "assets/svg/locate_me.svg",
//                                 "label": "Locate Me"
//                             }
//                         ],
//                         "customHandler": {
//                             "added": {
//                                 "function": "updateTabList",
//                                 "identificationField": "name"
//                             },
//                             "removed": {
//                                 "function": "removeTab",
//                                 "identificationField": "name"
//                             }
//                         }
//                     }
//                 ]
//             },
//             {
//                 "domainType": "app_configuration",
//                 "domainValues": [
//                     {
//                         "name": "locationPopup",
//                         "type": "boolean",
//                         "value": true,
//                         "docUrl": "",
//                         "domainType": "app_configuration",
//                         "description": "Show android location permission popup when the home screen load first time",
//                         "possibleVals": []
//                     },
//                     {
//                         "name": "locationPopupOnOrder",
//                         "type": "boolean",
//                         "value": true,
//                         "docUrl": "",
//                         "domainType": "app_configuration",
//                         "description": "Show android location permission popup when the home screen load first time",
//                         "possibleVals": []
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     }
// ];
